import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiSettings, FiTag, FiBook, FiCalendar } from 'react-icons/fi';

const AdminNav = () => {
  const location = useLocation();

  const navItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: <FiHome /> },
    { path: '/admin/courses', label: 'Courses', icon: <FiBook /> },
    { path: '/admin/availability', label: 'Availability', icon: <FiCalendar /> },
    { path: '/admin/categories', label: 'Categories', icon: <FiTag /> },
    { path: '/admin/settings', label: 'Site Settings', icon: <FiSettings /> }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="bg-white shadow-md mb-6">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex space-x-1 overflow-x-auto">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-2 px-6 py-4 font-semibold whitespace-nowrap border-b-2 transition ${
                isActive(item.path)
                  ? 'border-primary-500 text-primary-600 bg-primary-50'
                  : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default AdminNav;

